import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, InputNumber, notification} from 'antd';

import {addTax} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {bindActionCreators} from "redux";
import {formItemLayout} from "../utils/style";

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddTaxForm extends Component {
  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {dispensaryId} = this.props;
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.addTax({...values, dispensaryId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    return (
      <Card title="Add Tax">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Description"
          >
            {getFieldDecorator('description', {
              initialValue: ''
            })(
              <TextArea />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Registration Number"
          >
            {getFieldDecorator('registrationNumber', {
              initialValue: ''
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Rate"
          >
            {getFieldDecorator('rate', {
              rules: [{
                required: true,
                message: 'Rate is required'
              }, {
                type: 'number',
                min: 0.001,
                max: 0.999,
                message: 'Rate must be a fractional number'
              }]
            })(
              <InputNumber />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Add Tax
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

AddTaxForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispensaryId: PropTypes.string.isRequired,
  addTax: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

const AddTaxPage = Form.create()(AddTaxForm);

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  loading: state.tax.addingTax,
});

const mapDispatchToProps = dispatch => ({
  addTax: bindActionCreators(addTax, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddTaxPage);



// WEBPACK FOOTER //
// ./src/Tax/AddTaxPage.js